<div>
    <form name="ModuleForm" (ngSubmit)="Validate(ModuleForm)" #ModuleForm="ngForm">
        <div class="card border-radius-0 mt-1 p-0">
            <div class="card-header">
                TAT Master
            </div>
            <div class="card-body p-1">
                <table datatable [dtOptions]="dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered pt-2">
                    <thead class="table-light">
                        <tr>
                            <th>Module Name</th>
                            <th>TAT(Days)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let element of ModuleData">
                            <td>{{element.ModuleName}}</td>
                            <td style="width: 12%;">
                                <input name="TAT{{element.WebESSModuleMasterID}}" placeholder="Ex. 2"
                                    [(ngModel)]="element.DefaultTAT_InDays" #TAT="ngModel" type="text" maxlength="3"
                                    pattern="^[0-9]\d*$" (keypress)="common.NumberOnly($event)"
                                    [ngClass]="{'ng-invalid': common.parseFloat(element.DefaultTAT_InDays) > 99}"
                                    maxlength="2" required>
                                <div *ngIf="TAT.hasError('required') || TAT.hasError('min') || TAT.hasError('max')">
                                    <div style="color: red;">Please enter TAT between 0 to 99 days.</div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer">
                <div class="row">
                    <div class="col">
                    </div>
                    <div class="col-auto">
                        <button *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="sample"
                            (click)="exportToExcel()" type="button">
                            <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Excel':'Loading...'}}
                        </button>&nbsp;
                        <button *ngIf="this.common.PageRight.IsEdit" type="submit"
                            class="btn btn-sm btn-primary text-nowrap" [disabled]="isDisabled"><i class="bi bi-save"
                                *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Save':'Loading...'}}</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>